import { render, staticRenderFns } from "./GuiaTissOpme.vue?vue&type=template&id=308b5547"
import script from "./GuiaTissOpme.vue?vue&type=script&lang=ts"
export * from "./GuiaTissOpme.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports